// -----------------------------------------------------------------------------
//  Orari verso il backend: ISTANTI, non orologi da parete.
//
//  ⚠️ Una stringa senza fuso («2026-09-15 14:00:00») non è un istante: il
//  backend la interpreterebbe col fuso DEL SERVER e il browser la mostrerebbe
//  in quello DELL'UTENTE, quindi con server in UTC l'orario si sposterebbe:
//
//    scelto 14:00 -> server Europe/Rome -> DB 12:00 -> mostrato 14:00  ✔
//    scelto 14:00 -> server UTC         -> DB 14:00 -> mostrato 16:00  ✘
//
//  Il browser conosce il fuso dell'utente, quindi è il browser a produrre
//  l'istante. Il server non deve indovinare.
// -----------------------------------------------------------------------------

/**
 * Data (`YYYY-MM-DD`) + ora (`HH:MM`) scelte dall'utente -> istante ISO 8601.
 *
 * `new Date('2026-09-15T14:00:00')` è interpretato dal browser come ora
 * LOCALE dell'utente: `toISOString()` lo trasforma nell'istante assoluto
 * corrispondente. Il risultato è corretto qualunque sia il fuso del server.
 *
 * Ritorna null se data od ora mancano: meglio niente che un istante inventato.
 */
export function toInstant(date, hhmm) {
  if (!date || !hhmm) return null;
  const d = new Date(`${date}T${hhmm}:00`);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/** Il giorno di oggi (`YYYY-MM-DD`) in ora locale, da confrontare col `value-format` dei calendari. */
export function giornoDiOggi() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export default { toInstant, giornoDiOggi };
